import { gql } from '@apollo/client';

const ORGANIZATION_USER_MUTATION_FRAGMENT = gql`
    fragment mutationOrganizationUserFragment on OrganizationUser {
        _id
        email
        firstName
        lastName
        role
        deletedAt
        createdDate
        active
        isMemberActive
        humanId
        higherUpId
        file {
            _id
            name
            url
        }
    }
`;

const ORGANIZATION_USER_FRAGMENT = gql`
    fragment organizationUserFragment on OrganizationUser {
        _id
        email
        firstName
        lastName
        role
        deletedAt
        createdDate
        active
        isMemberActive
        totalSubordinates
        humanId
        color
        higherUpId
        subordinates {

            _id
            email
            firstName
            lastName
            role
            deletedAt
            createdDate
            active
            color
            isMemberActive
        }
        higherUps {

            _id
            email
            firstName
            lastName
            role
            deletedAt
            createdDate
            active
            color
            isMemberActive
            higherUpId
        }
        file {
            _id
            name
            url
        }
        jobOfferStatsOrgUser {
            jobs {
                total
            }
        }
    }
`;

export const GET_ORGANIZATION_USER_PRO = gql`
    ${ORGANIZATION_USER_FRAGMENT}
    query {
        list: getAllOrganizationUser {
            ...organizationUserFragment
        }
    }
`;

export const GET_ORGANIZATION_USER_PAGINATION = gql`
    query getOrganizationUserWithPaginations($pagination: Pagination, $sortBy: String, $sort: SortInput, $query: String, $higherUpId: ID, $deep: Boolean, $filter: OrganizationUserFilterInput) {
        getOrganizationUserWithPaginations(pagination: $pagination, sortBy: $sortBy, sort: $sort, query: $query, higherUpId: $higherUpId, deep: $deep, filter: $filter) {
            docs {
                ...organizationUserFragment
            }
            meta {
                totalDocs
                limit
                page
                nextPage
                prevPage
                totalPages
                hasPrevPage
                hasNextPage
                pagingCounter
            }
        }
    }
    ${ORGANIZATION_USER_FRAGMENT}
`;

export const GET_ORGANIZATION_USERS_UPERCUT = gql`
    query getOrganizationUsersUpercut($pagination: Pagination, $sortBy: String, $sort: SortInput, $query: String, $higherUpId: ID, $deep: Boolean, $proId: ID, $filter: OrganizationUserFilterInput) {
        getOrganizationUsersUpercut(pagination: $pagination, sortBy: $sortBy, sort: $sort, query: $query, higherUpId: $higherUpId, deep: $deep, proId: $proId, filter: $filter) {
            docs {
                ...organizationUserFragment
            }
            meta {
                totalDocs
                limit
                page
                nextPage
                prevPage
                totalPages
                hasPrevPage
                hasNextPage
                pagingCounter
            }
        }
    }
    ${ORGANIZATION_USER_FRAGMENT}
`;

export const GET_DETAIL_ORGANIZATION_USER_PRO = gql`
    query($id: ID!, $proId: ID) {
        getOrganizationUser(id: $id, proId: $proId) {
            ...organizationUserFragment
        }
    }
    ${ORGANIZATION_USER_FRAGMENT}
`;

export const ADD_ORGANIZATION_USER_PRO = gql`
    mutation addOrganizationUser($request: RequestOrganizationUser, $proId: ID) {
        addOrganizationUser(request: $request, proId: $proId) {
            ...mutationOrganizationUserFragment
            higherUp {
                ...organizationUserFragment
            }
        }
    }
    ${ORGANIZATION_USER_MUTATION_FRAGMENT}
    ${ORGANIZATION_USER_FRAGMENT}
`;

export const UPDATE_ORGANIZATION_USER_PRO = gql`
    mutation updateOrganizationUser($request: RequestOrganizationUser, $proId: ID) {
        updateOrganizationUser(request: $request, proId: $proId) {
            ...mutationOrganizationUserFragment
            higherUp {
                ...organizationUserFragment
            }
        }
    }
    ${ORGANIZATION_USER_MUTATION_FRAGMENT}
    ${ORGANIZATION_USER_FRAGMENT}
`;

export const DELETE_ORGANIZATION_USER_PRO = gql`
    ${ORGANIZATION_USER_FRAGMENT}
    mutation deleteOrganizationUser($id: ID!, $proId: ID) {
        deleteOrganizationUser(id: $id, proId: $proId) {
            ...organizationUserFragment
        }
    }
`;

const ORGANIZATION_USER_TOKEN_FRAGMENT = gql`
    fragment organizationUserTokenFragment on ActiveAccountOrganizationUser {
        userId
        token
        firstName
        lastName
        role
        proId
        isMemberActive
        active
    }
`;

export const ACTIVATE_ORGANIZATION_USER_PRO = gql`
    ${ORGANIZATION_USER_TOKEN_FRAGMENT}
    mutation activateOrganizationUser($email: String, $tokenActived: String!) {
        activateOrganizationUser(email: $email, tokenActived: $tokenActived) {
            ...organizationUserTokenFragment
        }
    }
`;

const LOGIN_PAYLOAD = `
    token
    tokenExpiration
    userId
    adminProId
    role
    bossFirstname
    bossEmail
    name
    email
    status
    active
    deletedDate
    professions
    photo
    specialties
    commercialName
    fullName
    onboardingCompleteDate
    changePassword
    accessResetPasswordLink
    acceptTnc
`;

export const RESET_PASSWORD_ORGANIZATION_USER_PRO = gql`
    mutation resetPasswordOrganizationUser($payload: RequestResetPasswordOrganizationUser, $proId: ID) {
        resetPasswordOrganizationUser(payload: $payload, proId: $proId) {
           ${LOGIN_PAYLOAD}
        }
    }
`;

export const RESEND_INVITATION_ORGANIZATION_USER_PRO = gql`
    mutation resendInvitationOrganizationUser($payload: RequestResendInvitationOrganizationUser, $proId: ID) {
        resendInvitationOrganizationUser(payload: $payload, proId: $proId)
    }
`;

export const GET_AVAILABLE_HIGHER_UPS = gql`
    query getAvailableHigherUps($proId: ID!) {
        getAvailableHigherUps(proId: $proId) {
            _id
            firstName
            lastName
            email
            role
            color
            file {
                _id
                url
            }
        }
    }
`;

export const GET_AVAILABLE_HIGHER_UPS_UPERCUT = gql`
    query getAvailableHigherUpsUpercut($proId: ID!) {
        getAvailableHigherUpsUpercut(proId: $proId) {
            _id
            firstName
            lastName
            email
            role
            color
            file {
                _id
                url
            }
        }
    }
`;
